export default class App {
  get host(): string {
    return window.location.host;
  }
}